export const USER_ROLES = {
  USER: 0,
  ADMIN: 1,
  SUBSCRIBER: 2,
}
